import { render, staticRenderFns } from "./RemoveDocumentModalNew.vue?vue&type=template&id=08cbef79"
import script from "./RemoveDocumentModalNew.vue?vue&type=script&lang=ts"
export * from "./RemoveDocumentModalNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08cbef79')) {
      api.createRecord('08cbef79', component.options)
    } else {
      api.reload('08cbef79', component.options)
    }
    module.hot.accept("./RemoveDocumentModalNew.vue?vue&type=template&id=08cbef79", function () {
      api.rerender('08cbef79', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/documents/RemoveDocumentModalNew.vue"
export default component.exports